import Image from './src/image'
export default Image
export { getFastlyUrl } from './src/image'
